
































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableColumnFixedType } from 'element-ui/types/table-column'
import TableColumnButton, { Button, ButtonModel } from './TableColumnButton.vue'
import TableColumnButtonGroup, {
  ButtonGroup
} from './TableColumnButtonGroup.vue'

export interface ColumnConfig {
  prop: string
  label?: string
  width?: number
  align?: 'left' | 'center' | 'right'
  fixed?: TableColumnFixedType
  type?: Button | ButtonGroup
  button?: ButtonModel
  slot?: Boolean
  formatter?: Function
}

@Component({
  components: {
    TableColumnButton,
    TableColumnButtonGroup
  }
})
export default class TableColumn extends Vue {
  @Prop({ type: Object, required: true }) column!: ColumnConfig
}
